import styled, { css } from 'styled-components';

import { colors, media } from '../../../core';
import { NavLink } from './NavLinkWithSubMenu/styles';

// interfaces
interface ColorProps {
  color?: string;
}

interface MenuIsOpenProps {
  menuIsOpen: boolean;
}

export const NavWrapper = styled.nav<MenuIsOpenProps>`
  background: ${colors.white};
  box-shadow: 0 0.375rem 0.5rem 0 rgb(0, 0, 0, 5%);
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  ${media.tabletMedium} {
    position: ${(props) => (props.menuIsOpen ? 'fixed' : 'sticky')};
    height: 100%;
    width: 100%;
  }
  a {
    display: inline-block;
  }
`;

export const NavTop = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.navBorderColor || colors.edgewater};
  ${media.tabletMedium} {
    display: none;
  }
  a {
    padding: 1.5rem 0;
  }
`;

export const NavBottom = styled.div<MenuIsOpenProps>`
  transition: height 500ms ease-in-out, opacity 500ms ease-in-out;
  ${media.tabletMedium} {
    position: absolute;
    top: 5rem;
    left: 0;
    height: ${({ menuIsOpen }) => (menuIsOpen ? '100vh' : '0vh')};
    width: 100%;
    background-color: ${colors.white};
    border-top: 1px solid ${({ theme }) => theme.navBorderColor || colors.edgewater};
    opacity: ${({ menuIsOpen }) => (menuIsOpen ? '1' : '0')};
    pointer-events: ${({ menuIsOpen }) => (menuIsOpen ? 'all' : 'none')};
    z-index: ${({ menuIsOpen }) => (menuIsOpen ? 5 : -5)};
  }
  a {
    padding: 1.625rem 0;
  }
`;

export const NavDivider = styled.div<ColorProps>`
  background-color: ${({ color }) => color};
  height: 2.125rem;
  width: 1px;
`;

const NavInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NavTopInner = styled(NavInner)`
  padding: 0 2rem;
`;

export const NavBottomInner = styled(NavInner)`
  padding: 0 0 0 2rem;
  ${media.tabletMedium} {
    flex-direction: column-reverse;
    padding: 0;
  }
`;

const baseNavMenuStyles = css`
  display: flex;
  align-items: center;
`;

export const NavMenuTopRight = styled.ul`
  ${baseNavMenuStyles};
  align-items: stretch;
  min-height: 70px;
  ${NavLink} {
    display: flex;
    align-items: center;
  }
`;

export const NavMenuBottomLeft = styled.ul`
  ${baseNavMenuStyles};
  ${media.tabletMedium} {
    align-items: flex-start;
    flex-direction: column;
    padding: 0 1.25rem;
    width: 100vw;
    li {
      margin-right: 0;
      width: 100%;
      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
`;

export const NavMenuBottomRight = styled.ul`
  ${baseNavMenuStyles};
  background-color: ${({ theme }) => theme.navMenuItemBackgroundColor || colors.whiteIce};
  padding: 0 2rem;
  ${media.tabletMedium} {
    line-height: 1.25;
    justify-content: center;
    text-align: center;
    width: 100vw;
  }
`;

export const NavMobile = styled.div`
  display: none;
  ${media.tabletMedium} {
    background-color: ${colors.white};
    display: block;
    padding: 1.5rem 0;
    width: 100vw;
  }
`;

export const NavMobileMenu = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
`;

export const HamburgerMenuLine = styled.span`
  background-color: ${({ theme }) => theme.navMenuHamburgerColor || colors.darkCerulean};
  display: block;
  height: 2px;
  width: 2.165rem;
  transition: transform 300ms ease-in-out;
`;

const CLOSED_SUB_MENU = 'transform: rotate(0) translateY(0)';
const OPEN_TOP_LINE = 'rotate(45deg) translateY(7px)';
const OPEN_BOTTOM_LINE = 'rotate(-45deg) translateY(-7px)';

export const HamburgerMenu = styled.button<MenuIsOpenProps>`
  background-color: transparent;
  border: none;
  ${HamburgerMenuLine} {
    &:first-child {
      margin-bottom: 8px;
      transform: ${({ menuIsOpen }) => (menuIsOpen ? OPEN_TOP_LINE : CLOSED_SUB_MENU)};
    }
    &:nth-last-child(2) {
      transform: ${({ menuIsOpen }) => (menuIsOpen ? OPEN_BOTTOM_LINE : CLOSED_SUB_MENU)};
    }
  }
`;

export const MobileSignInLink = styled.a`
  color: ${({ theme }) => theme.navMobileSignInLinkColor || colors.darkCerulean};
  font-size: 1.165rem;
  font-weight: 500;
  line-height: 1.7;
`;

export const Space = styled.div`
  width: 2.165rem;
`;
